import { OktaAuth } from '@okta/okta-auth-js';

// Same Okta tenant, separate OIDC (SPA) apps per environment — mirrors the
// previous backend's utils/okta_constants.py::get_okta_client_id.
const OKTA_ISSUER = 'https://contentsquare.okta.com';
const OKTA_CLIENT_ID_PRODUCTION = '0oaxg8xi371QLY7zM417';
const OKTA_CLIENT_ID_STAGING = '0oaxg8erajDaV731F417';

function getOktaClientId(hostname) {
  return hostname.includes('production') ? OKTA_CLIENT_ID_PRODUCTION : OKTA_CLIENT_ID_STAGING;
}

const oktaAuth = new OktaAuth({
  issuer: OKTA_ISSUER,
  clientId: getOktaClientId(window.location.hostname),
  redirectUri: `${window.location.origin}/login/callback`,
  scopes: ['openid', 'profile', 'email', 'offline_access'],
  pkce: true,
  tokenManager: {
    autoRenew: true,
    storage: 'localStorage',
  },
});

// Required for autoRenew/token background services to run. Kicked off here,
// at module load, so it's underway before any component reads a token.
oktaAuth.start();

export default oktaAuth;
